import { render, staticRenderFns } from "./DeleteDisk.vue?vue&type=template&id=b747d20c"
import script from "./DeleteDisk.vue?vue&type=script&lang=js"
export * from "./DeleteDisk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports